/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
};

const LinkIcon = ({ color = '#222', backgroundColor = '#FFF', className = null }) => (
    <svg
        width="34.18px"
        height="34.18px"
        viewBox="0 0 34.18 34.18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fill={backgroundColor}
            d="M31.65,0H2.53C1.13,0,0,1.1,0,2.45v29.28c0,1.35,1.13,2.45,2.53,2.45h29.12c1.4,0,2.53-1.1,2.53-2.45V2.45c0-1.35-1.13-2.45-2.53-2.45Z"
        />
        <g>
            <path
                fill={color}
                d="M16.27,23.55l-1.82,1.82c-1.55,1.55-4.07,1.55-5.62,0-.75-.75-1.16-1.75-1.16-2.81s.41-2.06,1.16-2.81l3.65-3.65c1.55-1.55,4.07-1.55,5.62,0,.46.46,1.21.46,1.67,0,.46-.46.46-1.21,0-1.67-2.47-2.47-6.49-2.47-8.96,0l-3.65,3.65c-1.2,1.2-1.86,2.79-1.86,4.48s.66,3.28,1.86,4.48c1.24,1.24,2.86,1.85,4.48,1.85s3.25-.62,4.48-1.85l1.82-1.82c.46-.46.46-1.21,0-1.67-.46-.46-1.21-.46-1.67,0Z"
            />
            <path
                fill={color}
                d="M27.06,7.14c-1.2-1.2-2.79-1.86-4.48-1.86s-3.28.66-4.48,1.86l-1.82,1.82c-.46.46-.46,1.21,0,1.67.46.46,1.21.46,1.67,0l1.82-1.82c.75-.75,1.75-1.16,2.81-1.16s2.06.41,2.81,1.16c.75.75,1.16,1.75,1.16,2.81s-.41,2.06-1.16,2.81l-3.65,3.65c-1.55,1.55-4.07,1.55-5.62,0-.46-.46-1.21-.46-1.67,0-.46.46-.46,1.21,0,1.67,1.24,1.24,2.86,1.85,4.48,1.85s3.25-.62,4.48-1.85l3.65-3.65c1.2-1.2,1.86-2.79,1.86-4.48s-.66-3.28-1.86-4.48Z"
            />
        </g>
    </svg>
);

LinkIcon.propTypes = propTypes;

export default LinkIcon;
